import type { EmailIngestorState } from 'client/js/redux/domains/EmailIngestor/EmailIngestor.types';

export const INIT_STATE: EmailIngestorState = {
  data: [],
  pagination: {
    sort: {
      field: 'updated',
      order: 'DESC',
    },
    results_per_page: 10,
    total: 0,
  },
};
